module.exports = __webpack_public_path__ + "static/media/logo_no_bg.906c99c5.png";